module.exports = __webpack_public_path__ + "img/social-media.fda49bef.jpg";